import { RecomendedSolution } from './recomended-solution.model';
import { Book } from './book.model';
import { Article } from './article.model';

export class ArticleRecomendation {
    artigos: Article[];
    livros: Book[];
    solucoes: RecomendedSolution[];

    constructor(model?: ArticleRecomendation) {
        this.artigos = model ? model.artigos : [];
        this.livros = model ? model.livros : [];
        this.solucoes = model ? model.solucoes : [];
    }
}